import { render, staticRenderFns } from "./Base.vue?vue&type=template&id=bfd7cb82"
import script from "./Base.ts?vue&type=script&lang=js&external"
export * from "./Base.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports